import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles, withTheme } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import withWidth from '@material-ui/core/withWidth';
import AlarmIcon from '@material-ui/icons/Alarm';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { UserConsumer } from './providers/UserProvider';
import { globalStyles as styles } from './style/gstheme';

class MaintenanceWarning extends Component {

  state = {
    currentTime: Date.now()
  };

  componentDidMount() {
    this.hcTimeout = setTimeout(() => this.isHappening(), 60000);
  }

  isHappening = () => {
    if (this.hcTimeout) clearTimeout(this.hcTimeout);
    this.setState({ currentTime: Date.now() });
    this.hcTimeout = setTimeout(() => this.isHappening(), 60000);
  };

  componentWillUnmount() {
    if (this.hcTimeout) clearTimeout(this.hcTimeout);
  }

  render() {

    const { width, classes, theme } = this.props;

    return (
      <UserConsumer>
        {({ user, acknowledgeMaintenance }) => {
          const startTime = user.adminWindow && user.adminWindow.startTime ? new Date(user.adminWindow.startTime) : null;
          const endTime = user.adminWindow && user.adminWindow.endTime ? new Date(user.adminWindow.endTime) : null;
          const countdown = startTime && (startTime - Date.now() < 600000) ?
            Math.floor((startTime - this.state.currentTime) / 60000)
            :
            null;
          return <div
            className={classes.infoBar}
            style={{
              color: 'white',
              backgroundColor: theme.palette.error.main
            }}>
            <div className={classes.infoBarIcon}>
              <AlarmIcon />
            </div>
            <div className={classes.infoBarMessage}>
              <Typography variant="body2">
                {width !== "xs" && width !== "sm" &&
                  <span>We will be conducting routine maintenance on </span>
                }
                {startTime.toLocaleString()}
                {countdown > 0 && <span> ({countdown} minutes from now)</span>}
                {countdown === 0 && <span> (Imminent)</span>}
                {endTime && width !== "xs" && width !== "sm" &&
                  <span> until {endTime.toLocaleString()}</span>
                }
              </Typography>
            </div>
            <span className={classes.infoBarAction}>
              <Tooltip title="Close notification">
                <IconButton size="small" onClick={acknowledgeMaintenance}>
                  <CloseIcon style={{ color: 'white' }} />
                </IconButton>
              </Tooltip>
            </span>
          </div>;
        }}
      </UserConsumer>
    );
  }
}

MaintenanceWarning.propTypes = {
  title: PropTypes.string,
  width: PropTypes.string,
  theme: PropTypes.object,
  classes: PropTypes.object
};

export default withWidth()(withTheme(withStyles(styles)(MaintenanceWarning)));
